import React from 'react';
import ReportTable from "../../../hoc/ReportTable/ReportTable";
import {ReportSectionHeader} from "../SectionHeader";


const LiabilityLossDistributionComponent = (props) => (
    <div>
        <ReportSectionHeader>
        
        <div style={{width: "70%", display: "block", float: "left", paddingTop: "1em"}}>Potential Embedded SCA Loss ( Present Day )</div><div style={{float: "left"}}>Potential Settlement Value <br /> (Empirical Settlement Rates)</div>
    	
        </ReportSectionHeader>

        <ReportTable
            settings={[
                {
                    header: '', 
                    accessor: 'name',
                    textOnly: true,
                    cellText: 'Estimated Rule 10b-5 Loss (000s)'
                },
                {
                    header: 'Potential Rule 10b-5 Aggregate Damages',
                    accessor: 'aggregateDamages',
 					dollarValue: true,
                    formatNumberWithCommas: true,
                    truncateDecimal: true,
                    inThousands: true,
                    centerRightJustified: true,
                    blockNull: true
                },
                {
                    header: '10th\n( '+(props.liabilityRates.settlementRate10Value*100).toFixed(2)+'% )',
                    accessor: 'potentialLoss10',
 					dollarValue: true,
                    formatNumberWithCommas: true,
                    truncateDecimal: true,
                    inThousands: true,
                    centerRightJustified: true,
                    blockNull: true
                },
                {
                    header: '25th\n( '+(props.liabilityRates.settlementRate25Value*100).toFixed(2)+'% )',
                    accessor: 'potentialLoss25',
 					dollarValue: true,
                    formatNumberWithCommas: true,
                    truncateDecimal: true,
                    inThousands: true,
                    centerRightJustified: true,
                    blockNull: true
                },
                {
                    header: 'Median\n( '+(props.liabilityRates.settlementRateValue*100).toFixed(2)+'% )',
                    accessor: 'potentialLoss50',
 					dollarValue: true,
                    formatNumberWithCommas: true,
                    truncateDecimal: true,
                    inThousands: true,
                    centerRightJustified: true,
                    blockNull: true
                },
                {
                    header: '75th\n( '+(props.liabilityRates.settlementRate75Value*100).toFixed(2)+'% )',
                    accessor: 'potentialLoss75',
 					dollarValue: true,
                    formatNumberWithCommas: true,
                    truncateDecimal: true,
                    inThousands: true,
                    centerRightJustified: true,
                    blockNull: true
                },
                {
                    header: '90th\n( '+(props.liabilityRates.settlementRate90Value*100).toFixed(2)+'% )',
                    accessor: 'potentialLoss90',
 					dollarValue: true,
                    formatNumberWithCommas: true,
                    truncateDecimal: true,
                    inThousands: true,
                    centerRightJustified: true,
                    blockNull: true
                },
                {
                    header: 'Mean\n( '+(props.liabilityRates.settlementRateMeanValue*100).toFixed(2)+'% )',
                    accessor: 'potentialLossMean',
 					dollarValue: true,
                    formatNumberWithCommas: true,
                    truncateDecimal: true,
                    inThousands: true,
                    centerRightJustified: true,
                    blockNull: true
                },
            ]}
            data={props.liabilityLoss}
            name={"liabilityLossDistribution"}
           
        />
    </div>
);


export default LiabilityLossDistributionComponent;


// WEBPACK FOOTER //
// ./src/common/components/LiabilityLossDistribution/LiabilityLossDistribution.js